import CardModule from '../CardModule/card-module'
import HighlightModule from '../HighlightModule/highlight-module'

const supportedGridModules = {
  card: CardModule,
  highlight: HighlightModule,
}

export default supportedGridModules
